export default __webpack_public_path__ + "static/media/flayer44.b7f06777.jpg";